/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './dispute_ledger_common';
import '../../common/currency';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "FinalizeDisputeWonRequest": {
                "fields": {
                  "context": {
                    "type": ".squareup.corporate_card.service.RequestContext",
                    "id": 1,
                    "rule": "optional"
                  },
                  "transactionToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "disputedMoney": {
                    "type": ".squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "wonMoney": {
                    "type": ".squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "reference": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "FinalizeDisputeWonResponse": {
                "fields": {
                  "result": {
                    "type": ".squareup.corporate_card.service.TransactionResult",
                    "id": 1,
                    "rule": "optional"
                  },
                  "errorMessage": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "finalizationEntryToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "additionalCreditEntryToken": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 5,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.FinalizeDisputeWonRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.FinalizeDisputeWonResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE FinalizeDisputeWonRequest @ squareup/corporate_card/service/finalize_dispute_won.proto at 11:1
 */
export const FinalizeDisputeWonRequest = $root.lookupType('squareup.corporate_card.service.FinalizeDisputeWonRequest');
fixType(FinalizeDisputeWonRequest, {
  context: {
    notEmpty: true
  },
  transactionToken: {
    notEmpty: true
  },
  disputedMoney: {
    notEmpty: true
  },
  wonMoney: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(FinalizeDisputeWonRequest);
/**
 * SOURCE FinalizeDisputeWonResponse @ squareup/corporate_card/service/finalize_dispute_won.proto at 38:1
 */
export const FinalizeDisputeWonResponse = $root.lookupType('squareup.corporate_card.service.FinalizeDisputeWonResponse');
fixType(FinalizeDisputeWonResponse, {
  result: {
    required: true
  }
});
Builder.createAndAttachToType(FinalizeDisputeWonResponse);